import { ApiCounty } from '../api-types/county.api';
import { County } from '../app-types/county.app';

/**
 * Transforms an ApiCounty object to an app-specific County object.
 * @description This function maps properties of the ApiCounty to the County interface.
 * It is used to convert data received from the API into a format that the application can work with.
 * @param input ApiCounty
 * @returns County
 */
export const transformApiCountyToAppCounty = (input: ApiCounty | undefined) => {
	const output: County = {
		id: input?.id,
		initial: input?.initial,
		specialistIntegrationService: input?.specialistIntegrationService,
		remark: input?.remark,
		display: input?.display,
		specialistHelpId: input?.specialistHelpId,
	};
	return output;
};

/**
 * Transforms an array of ApiCounty objects to an array of app-specific
 * County objects.
 * @param input Array of ApiCounty objects
 * @description Transforms an array of ApiCounty objects to an array of app-specific AppCounty objects.
 * @returns Array of app-specific County objects
 */
export const transformApiCountiesToAppCounties = (input: ApiCounty[]) => {
	const output: County[] = input.map(transformApiCountyToAppCounty);
	return output;
};

export const transformAppCountyToApiCounty = (input: County | undefined) => {
	const output: ApiCounty = {
		id: input?.id,
		initial: input?.initial,
		specialistIntegrationService: input?.specialistIntegrationService,
		remark: input?.remark,
		display: input?.display,
		specialistHelpId: input?.specialistHelpId,
	};
	return output;
};
